import clsx from "clsx";
import { CheckIcon } from "@phosphor-icons/react";
import { Ref } from "react";

export function FormSuccessHeading({
	className,
	headingRef,
	title,
	description,
	onClose,
}: {
	className?: string;
	headingRef: Ref<HTMLHeadingElement>;
	title: string;
	description: string;
	onClose: () => void;
}) {
	return (
		<>
			<div className={clsx(className, "yF-relative yF-p-8")}>
				<div className="yF-mx-auto yF-flex yF-h-20 yF-w-20 yF-items-center yF-justify-center yF-rounded-full yF-bg-[--yF-bullet-bg]">
					<CheckIcon
						className="yF-h-10 yF-w-10 yF-text-[--yF-theme-color]"
						aria-hidden="true"
					/>
				</div>
				<div className="yF-mt-3 yF-text-center sm:yF-mt-5">
					<h3
						ref={headingRef}
						className="yF-text-[1.2rem] sm:yF-text-[1.5rem] lg:yF-text-[2rem] yF-mb-3 yF-font-semibold yF-leading-8 yF-text-[--yF-theme-h-text]"
					>
						{title}
					</h3>
					<div className="yF-mt-5 yF-mb-5">
						<p className="yF-text-md yF-text-gray-500 sm:yF-text-lg">
							{description}
						</p>
					</div>
					<div>
						<button
							type="button"
							className="yF-bg-[--yF-theme-color] hover:yF-bg-[--yF-hover-color] yF-cursor-pointer yF-text-white yF-text-md md:yF-text-lg yF-font-medium yF-px-4 yF-py-2 sm:yF-px-8 sm:yF-py-4 md:yF-py-2 yF-rounded-md yF-w-full md:yF-w-auto yF-transition-all"
							onClick={onClose}
						>
							Close
						</button>
					</div>
				</div>
			</div>
		</>
	);
}
